import { fileUtil } from "core/util";
import { FileItem } from "types/form";
import { FileItemStatusEnum } from "types/enums";
import { vehicleChangeAttachmentsApi } from "serverApi";

export default function useUploadRemoveAttachment(idObject: string, changeSheetId: string) {
    async function getFileData(file: File): Promise<Partial<FileItem>> {
        const data = await fileUtil.readFileAsBase64(file);
        return { data };
    }

    const removeAttachment = async (idAttachment: string) => {
        const [error, res] = await vehicleChangeAttachmentsApi.deleteAttachment(idObject, changeSheetId, idAttachment);
    };

    const uploadAttachment = async (attachmentType: string, fileItem: FileItem) => {
        const data = await getFileData(fileItem.file);

        const [error, res] = await vehicleChangeAttachmentsApi.uploadAttachment(idObject, changeSheetId, attachmentType, {
            ...fileItem,
            ...data,
        });

        return {
            uploadId: res.body.id,
            uploadStatus: FileItemStatusEnum.UPLOADED,
        };
    };

    return {
        removeAttachment,
        uploadAttachment,
    };
}
